import moment from "moment";
import { useState } from "react";
import Datepicker, { DateValueType } from "react-tailwindcss-datepicker";
import { Modal } from "src/components/DialogComponent";
import TGButton from "src/components/ui/TGButton";
import { FlexRow, FlexCol } from "src/utils/flexLayouts";
import { SelectIcon } from "./SelectIcon";

function SelectReviewDate({
  title,
  initial,
  onResult,
  modalTitle,
  modalDescription,
  filters,
  zIndex,
}: {
  title: string;
  initial: Date;
  onResult: (date: Date) => void;
  modalTitle: string;
  modalDescription: string;
  filters?: {
    start: Date;
    end: Date;
  };
  zIndex?: number;
}) {
  const [openDialog, setOpenDialog] = useState(false);
  const [reviewDate, setReviewDate] = useState<Date | null>(initial);

  function toggleDialog(state: boolean) {
    setOpenDialog(state);
  }

  function changeDate(value: DateValueType) {
    const result = value?.startDate ? moment.utc(value.startDate).toDate() : null;

    if (result) {
      setReviewDate(result);
    }
  }

  function BackButton() {
    setOpenDialog(false);
  }

  function submitDate() {
    if (!reviewDate) {
      return;
    }

    setOpenDialog(false);
    onResult(reviewDate);
  }

  return (
    <FlexRow className="flex items-center justify-between font-medium text-black p-9 flex-nowrap">
      <FlexCol className="text-[18px]">
        {title}: {reviewDate ? moment(reviewDate).locale("ru").format("DD.MM.YYYY") : "Укажите дату"}
      </FlexCol>
      <FlexCol className="shrink-0">
        <button onClick={() => toggleDialog(true)}>
          <SelectIcon isSelect={!!reviewDate} />
        </button>
      </FlexCol>
      <Modal zIndex={zIndex ? zIndex + 10 : 120} open={openDialog} toggleDialog={toggleDialog}>
        <header className="px-10 pb-4">
          <h2>{modalTitle}</h2>
        </header>

        <div className="px-10 py-5 grow">
          <h4 className="text-black mb-2.5">{modalDescription}</h4>
          <div>
            <Datepicker
              value={{ startDate: reviewDate, endDate: reviewDate }}
              i18n="ru"
              readOnly={true}
              inputClassName="text-left cursor-default block w-full text-base rounded-md border border-[#DFE4EA] py-3 pl-5 pr-4 text-black outline-none shadow-custom"
              useRange={false}
              toggleClassName="absolute right-0 top-0 h-full px-3 text-gray-400 focus:outline-none disabled:opacity-40 disabled:cursor-not-allowed"
              containerClassName={"scale-x-1 relative"}
              asSingle={true}
              primaryColor="blue"
              onChange={changeDate}
              displayFormat="DD.MM.YYYY"
              startWeekOn="mon"
              minDate={filters ? filters.start : new Date()}
              maxDate={filters ? filters.end : null}
              popoverDirection="down"
            />
          </div>
        </div>

        <footer className="flex justify-between px-10 pt-10 mt-4 border-t">
          <TGButton onClick={BackButton}>Отмена</TGButton>
          <TGButton disabled={!reviewDate} color="bluedark" onClick={submitDate}>
            Сохранить
          </TGButton>
        </footer>
      </Modal>
    </FlexRow>
  );
}

export default SelectReviewDate;
